"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendApi = void 0;
var config_1 = require("../server/config");
var esm_1 = require("../../dist/esm");
// class IOption {
//   url: string
// }
var BackendApi = /** @class */ (function () {
    function BackendApi(option) {
        this._url = option.url;
        this._rainbowWebsocket = new esm_1.default({
            url: this._url
        });
    }
    BackendApi.prototype.version = function () {
        return this._rainbowWebsocket.request({
            data: {
                method: 'version',
                params: {
                    latest: true
                }
            }
        });
    };
    return BackendApi;
}());
exports.BackendApi = BackendApi;
window.backendApi = new BackendApi({
    url: config_1.serverConfig.host + ":" + config_1.serverConfig.port
});
var api = new BackendApi({
    url: config_1.serverConfig.host + ':' + config_1.serverConfig.port
});
